import { render, staticRenderFns } from "./CargaPrecoDetalhe.vue?vue&type=template&id=6207c08e&scoped=true&"
import script from "./CargaPrecoDetalhe.vue?vue&type=script&lang=js&"
export * from "./CargaPrecoDetalhe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6207c08e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
